<template>
  <div id="mapBox"></div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
// 自定义图标（缩放有点位偏移问题）
import zwfwIcon from "../../assets/img/zwfwIcon.png";
import jyzyIcon from "../../assets/img/jyzyIcon.png";
import ylwsIcon from "../../assets/img/ylwsIcon.png";
import ylfwIcon from "../../assets/img/ylfwIcon.png";
window._AMapSecurityConfig = {
  securityJsCode: "cc18b4e487c33921dc2b0a5ddd71f80d",
};
export default {
  props: {
    mapData: [],
    type: 0,
  },
  data() {
    return {
      map: null,
      // infoWindow: null, //信息窗
      winInfo: [],
    };
  },
  watch: {
    mapData: {
      handler(newVal, oldVal) {
        this.initMap();
      },
    },
  },
  methods: {
    initMap() {
      AMapLoader.load({
        key: "93dd0036e71008f9dbfccd3e3c0c50cb", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map("mapBox", {
            //设置地图容器id
            viewMode: "2D", //是否为3D地图模式
            zoom: 11, //初始化地图级别
            center: [102.650782, 29.344236], //初始化地图中心点位置
          });
          for (let i = 0; i < this.mapData.length; i++) {
            var marker = new AMap.Marker({
              position: this.mapData[i].position, //不同标记点的经纬度
              map: this.map,
            });
            marker.content = ` <h4> ${this.mapData[i].name
              } </h4><p><b>电话：</b> ${this.mapData[i].phoneNumbe ? this.mapData[i].phoneNumbe : "暂无"
              }</p><p><b>地址：</b> ${this.mapData[i].address ? this.mapData[i].address : "暂无"
              }</p><p style="${this.mapData[i].workTime ? "display:inherit" : "display:none"
              }"><b>办公时间：</b>${this.mapData[i].workTime}</p>`;
            marker.on("click", this.markerClick);
          }
          // 将创建的点标记添加到已有的地图实例：
          this.map.add([marker]);
          // 设置窗体内容
          var infoWindow = new AMap.InfoWindow({
            // isCustom: true,  //是否自定义窗体。设为true时，信息窗体外框及内容完全按照content所设的值添加（默认为false，即在系统默认的信息窗体外框中显示content内容）--为ture时信息窗没有指向标点的箭头了
            content: ` <h4> ${this.mapData[0].name
              } </h4><p><b>电话：</b> ${this.mapData[0].phoneNumbe ? this.mapData[0].phoneNumbe : "暂无"
              }</p><p><b>地址：</b> ${this.mapData[0].address ? this.mapData[0].address : "暂无"
              }</p><p style="${this.mapData[0].workTime ? "display:inherit" : "display:none"
              }"><b>办公时间：</b>${this.mapData[0].workTime}</p>`,
            offset: new AMap.Pixel(15, -35),
            autoMove: true, //是否自动调整窗体到视野内（当信息窗体超出视野范围时，通过该属性设置是否自动平移地图，使信息窗体完全显示）
            avoid:[55,20,20,20],//autoMove 为 true 时，自动平移到视野内后的上右下左的避让宽度。默认值： [20, 20, 20, 20]
            closeWhenClickMap: true, //控制是否在鼠标点击地图后关闭信息窗体，默认false，鼠标点击地图后不关闭信息窗体
            anchor: "bottom-center",
          });
          infoWindow.open(this.map, this.mapData[0].position);
          // 页面控件
          this.map.plugin(["AMap.ControlBar", "AMap.ToolBar"], () => {
            var controlBar = new AMap.ControlBar({ position: 'RT' });
            var toolBar = new AMap.ToolBar({ position: { top: '100px', right: '25px' } });
            this.map.addControl(controlBar);
            this.map.addControl(toolBar);
          });
        })
        .catch((e) => {
          // console.log(e);
        });
    },
    // 标点点击事件
    markerClick(e, pos) {
      // console.log(e, pos, '/')
      // console.log(this.map)
      // e为对象时是从点位触发的点击事件，e为字符串时是通过右侧列表点击触发的事件
      typeof e == "object"
        ? (this.winInfo = e.target.content)
        : (this.winInfo = e);
      // 设置窗体内容
      var infoWindow = new AMap.InfoWindow({
        // isCustom: true,  //是否自定义窗体。设为true时，信息窗体外框及内容完全按照content所设的值添加（默认为false，即在系统默认的信息窗体外框中显示content内容）--为ture时信息窗没有指向标点的箭头了
        content: this.winInfo,
        autoMove: true, //是否自动调整窗体到视野内（当信息窗体超出视野范围时，通过该属性设置是否自动平移地图，使信息窗体完全显示）
        avoid:[55,20,20,20],//autoMove 为 true 时，自动平移到视野内后的上右下左的避让宽度。默认值： [20, 20, 20, 20]
        offset: new AMap.Pixel(15, -35),
        closeWhenClickMap: true, //控制是否在鼠标点击地图后关闭信息窗体，默认false，鼠标点击地图后不关闭信息窗体
        anchor: "bottom-center",
      });
      // 打开窗体
      if (pos) {
        // console.log(pos,'dianw')
        this.map.setZoomAndCenter(11, pos);   
        //pos存在代表从右侧列表点击
        infoWindow.open(this.map, pos);
      } else {
        // console.log(e.pos)
        this.map.setZoomAndCenter(11, [e.pos]);    
        infoWindow.open(this.map, e.target.getPosition());
      }
    },
    // 不同地图类型标记点图标不同（自定义标点图标有缩放点位偏移问题--未使用）
    filterIcon(type) {
      switch (type) {
        case 0:
          // return '../../assets/img/zwfwIcon.png';
          return zwfwIcon;
        case 1:
          // return "../../assets/img/jyzyIcon.png";
          return jyzyIcon;
        case 3:
          // return "../../assets/img/ylwsIcon.png";
          return ylwsIcon;
        case 2:
          // return "../../assets/img/ylfwIcon.png";
          return ylfwIcon;
      }
    },
  },
  mounted() {
    //DOM初始化完成进行地图初始化
    this.initMap();
  },
};
</script>

<style scoped>
#mapBox {
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 680px;
}
</style>
